import { html } from 'lit'
import HedeliusBaseItem from '../base-item.js'

customElements.define(
    'hedelius-right-item-machining-center',
    class HedeliusRightItemMachiningCenter extends HedeliusBaseItem {
        renderAnchor() {
            return html`
                <li class="border-b border-b-gray-200 py-8">
                    <a
                        @click="${(e) => this._handleClick(e, this.node)}"
                        class="group flex justify-between gap-1 max-sm:flex-col"
                        href="${this.node.href}"
                    >
                        <div class="mb-3 flex flex-[5] flex-col gap-3 text-2xl font-black">
                            <span
                                class="mr-auto border-b-2 border-b-white transition-colors group-hover:border-b-hdls-red"
                            >
                                ${this.node.title}
                            </span>
                            <span class="plus-list -mt-3 text-base font-bold">
                                ${this.node.subtitle}
                            </span>
                            <div class="mt-2 text-base font-light">
                                ${(() => {
                                    const datapoints = []
                                    this.node.datasheet.forEach((item) => {
                                        datapoints.push(html`
                                            <div class="flex gap-2">
                                                <span>${item.title}</span>
                                                <span class="font-semibold">${item.value}</span>
                                            </div>
                                        `)
                                    })
                                    return datapoints
                                })()}
                            </div>
                        </div>
                        ${this.node.teaser_image &&
                        html`
                            <div class="flex-[6] justify-center">
                                <img
                                    class="object-contain"
                                    src="${this.node.teaser_image}-S400"
                                    alt="${this.node.image_alt}"
                                    title="${this.node.image_title}"
                                    loading="lazy"
                                />
                            </div>
                        `}
                    </a>
                </li>
            `
        }
    }
)
